import { React, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';

import NewNoticeModifyBox from './NewNoticeModifyBox';

function NoticeModifyView(props) {
  const { noticeId } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const [isProcess, setIsProcess] = useState(false);
  const [data, setData] = useState({title: '', content: ''});

  const BoxRef = useRef();

  // 공지사항 상세 정보 불러오기 //
  useEffect(() => {
    const requestData = {
      noticeId: noticeId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('notice/detail/zone', 'POST', requestData);
        if (responseData.status === 200) {
          setData(responseData.data[0]);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  function exitButtonClick() { 
    history.push('/notice/details/' + noticeId);
  }

  // 새로운 저장 버튼 클릭시 //
  function onClickNewVersionAddButtonClick() {
    if (isProcess) {
      alert(t('noticePage.alertProcessing'));
      return;
    }

    let title = BoxRef.current.getTitle();
    let content = BoxRef.current.getValue();
    let picture = BoxRef.current.getPicture();
    let isFixed = BoxRef.current.getIsFixed();

    if (title === undefined || title === '') {
      alert(t('noticePage.alertEnterTitle'));
      return;
    }

    if (content === undefined || content === '') {
      alert(t('noticePage.alertEnterContent'));
      return;
    }

    setIsProcess(true);

    let requestData = {
      noticeId: noticeId,
      storeId: window.sessionStorage.getItem('StoreId'),
      title: title,
      content: content,
      pictures: picture,
      isFixed: isFixed
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('notice/save2', 'POST', requestData);
        if (responseData.status === 200) history.push('/notice');
        else if (responseData.status === 201) alert(t('noticePage.alertExceedFixedNoticeLimit'));
        else if (responseData.status === 401) history.push('/');

        setIsProcess(false);
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <TopBarWrapper>
        <TextWrapper>
          <Title>{t('noticePage.title')}</Title>
          <Explanation>{t('noticePage.description')}</Explanation>
        </TextWrapper>
        <ButtonWrapper>
          <ExitButton onClick={exitButtonClick}>{t('noticePage.cancel')}</ExitButton>
          <AddButton onClick={onClickNewVersionAddButtonClick}>{t('noticePage.modifyAction')}</AddButton>
        </ButtonWrapper>
      </TopBarWrapper>
      <NewNoticeModifyBox ref={BoxRef} data={data}/>
    </TopLevelWrapper>
  )
}

export default NoticeModifyView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 20px;

  transition: all 0.3s ease-in-out;
`;

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 992px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  transition: all 0.2s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const AddButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 10px;

  height: 40px;

  border-radius: 6px;
  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;
